<template>
  <p>
    <Select
      v-model="ut"
      style="width:80px"
      class="mr-3"
      :transfer="true"
      :disabled="noShow || permission"
    >
      <Option v-for="it in utarr" :value="it.val" :key="it.val">{{it.text}}</Option>
    </Select>
    <Select
      v-if="!noShow"
      v-model="time"
      style="width:80px"
      :transfer="true"
      :disabled="permission"
    >
      <Option v-for="(it,idx) in getTimearr()" :value="it" :key="it+idx">{{it}}</Option>
    </Select>
    <Select
      v-else
      v-model="time"
      style="width:80px"
      :transfer="true"
      :disabled="true || permission"
    >
      <Option :value="7">7</Option>
    </Select>
    <!-- <TimePicker v-model="stime" type="time" placeholder="Select time" style="width: 100px" @on-change="dateChange"></TimePicker>
    <TimePicker v-model="etime" type="time" placeholder="Select time" style="width: 100px" @on-change="dateChange"></TimePicker>-->
    <!-- gameid == 16 下版会调整单位为日 显示开关盘时间 现在不能修改 -->
  </p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    row: Object,
    bettime: Object,
    gameid: Number
  },
  data () {
    return {
      utarr: [
        { val: 1, text: "秒" },
        { val: 2, text: "分钟" },
        { val: 3, text: "小时" },
      ],
      stime: '',
      etime: ''
    }
  },
  computed: {
    ...mapGetters(['getpermission']),
    noShow () {
      return this.row.betSeconds == 0 || this.row.betSeconds == 86400
    },
    ut: {
      get () {
        return this.bettime.ut
      },
      set (val) {
        let obj = {
          gameid: this.gameid,
          ut: val,
          time: val == 1 ? 75 : 1
        }
        this.$emit('getNewData', obj)
        this.$emit('update:bettime.ut', val, this.gameid)
      }
    },
    time: {
      get () {
        return this.bettime.time
      },
      set (val) {
        let obj = {
          gameid: this.gameid,
          ut: this.ut,
          time: val
        }
        this.$emit('getNewData', obj)
        this.$emit('update:bettime.time', val, this.gameid)
      }
    },
    permission () {
      return this.getpermission.gameset[5] == 0
    }
  },
  methods: {
    getTimearr () {
      let arr = []
      switch (this.ut) {
        case 1:
          arr = [75, 90]
          break;
        case 2:
          arr = [1, 3, 5, 6, 10, 20, 30]
          break;
        case 3:
          arr = [1, 2, 3, 4, 6, 8, 12]
          break;
      }
      return arr
    },
    dateChange () {
      // console.log([this.stime, this.etime])
    }
  }
}
</script>